"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const index_1 = require("../botones/index");
class TabHeaderView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onChange = (x) => {
            if (this.props.onChange) {
                this.props.onChange(x);
            }
        };
    }
    render() {
        const { value, items } = this.props;
        return (React.createElement("ul", { className: "nav nav-tabs" }, items.map((x, i) => React.createElement("li", { key: i, className: i == value ? "active" : "" },
            React.createElement(index_1.Link, { iconClass: x.iconClass, onClick: () => this.onChange(i) }, x.title)))));
    }
}
exports.TabHeaderView = TabHeaderView;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/tabs/tabHeader.js
// module id = 2258
// module chunks = 0